<script>
  export let axios;
  export let id;
  export let image;
  export let max;
  export let basketMode;
  let quantity = 1;
  let loading = false;
  let error = null;
  let modalOpen = false;
  // Simple access to cart API, no auth needed
  const addToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    loading = true;
    error = null;
    const userApi = axios.create({
      baseURL: window.location.origin,
      timeout: 30000,
      headers: {
        "Content-Type": "application/json",
      },
    });
    const items = [
      {
        id,
        quantity,
      },
    ];
    // console.log("::AddToCart", items);
    userApi
      .post(`/cart/add.js`, {
        items: items,
      })
      .catch((e) => {
        // i.e. if it is a legit axios + shopify error:
        error =
          e.response && e.response.data && e.response.data.description
            ? e.response.data.description
            : "There was a problem adding this product";
        console.log("AddToCart error:", error);
      })
      .then(() => {
        modalOpen = true;
        loading = false;
      });
  };
</script>

<div class="add-to-cart">
  <input type="number" min="1" {max} size="4" bind:value={quantity} />
  <button class="button" on:click={addToCart}
    >Add to {basketMode ? "Basket" : "Cart"}</button
  >
</div>
{#if modalOpen}
  <div class="modal-add-to-cart">
    <div class="_wrapper">
      <div class="_inner">
        {#if error}
          <!-- Should never occur, but JIC -->
          <div class="_content">
            <h3>Add to {basketMode ? "basket" : "cart"} error</h3>
            <div class="alert alert-danger">
              {error}
            </div>
            <p>Please try again with an alternative product or quantity.</p>
            <button
              class="button"
              on:click={(e) => {
                e.stopPropagation();
                e.stopImmediatePropagation();
                modalOpen = false;
              }}
            >
              Continue shopping
            </button>
          </div>
        {:else}
          <img alt="" src={image} />
          <div class="_content">
            <h3>Added to {basketMode ? "basket" : "cart"}</h3>
            <p class="_actions">
              <button
                class="button"
                on:click={(e) => {
                  e.stopPropagation();
                  e.stopImmediatePropagation();
                  modalOpen = false;
                }}
              >
                Continue shopping
              </button>
              <a href="/cart" class="button"
                >Go to {basketMode ? "basket" : "cart"}</a
              >
            </p>
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}

<style>
  /* Basic-as-possible layout styles for this modal (Similar to Amrita protocol builder intro) */
  .modal-add-to-cart {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    overflow: hidden;
    background: rgba(100, 100, 100, 0.3);
  }
  .modal-add-to-cart ._wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: absolute;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  .modal-add-to-cart ._inner {
    display: flex;
    max-width: 30em;
    min-width: 50vw;
    margin: 1em 0;
    background: white;
  }
  .modal-add-to-cart img {
    max-width: 200px;
  }
  .modal-add-to-cart ._content {
    padding: 2em;
  }
</style>
